{
  "verticals": {
    "accounting_treatment_simulator": {
      "title": "Simulateur de traitement comptable",
      "description": "Simulateur d'impact du traitement comptable (IFRS / US GAAP)"
    },
    "ai_ml": {
      "title": "IA/ML",
      "description": "Modèles d'apprentissage automatique traditionnels — données clients, scorage de risque, assurance et surveillance des transactions."
    },
    "allowance_models": {
      "title": "Modèles de provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues pour les portefeuilles entreprises."
    },
    "alm_interest_rate": {
      "title": "Taux d'intérêt ALM",
      "description": "Modèle de projection ALM des taux d'intérêt (multi-scénarios)"
    },
    "aml_tm": {
      "title": "AML/TM",
      "description": "TM à base de règles — logique de scénarios / seuils pour détecter les transactions suspectes"
    },
    "auto": {
      "title": "Automobile",
      "description": "Modèles de prêts et leasing auto — scorage à l'origination, valeur résiduelle et prévision des pertes."
    },
    "auto_allowance": {
      "title": "Provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues de prêts auto"
    },
    "auto_irb_lgd": {
      "title": "LGD IRB",
      "description": "LGD de prêts auto — dépréciation du véhicule et modélisation du recouvrement"
    },
    "auto_irb_pd": {
      "title": "PD IRB",
      "description": "PD de prêts auto — modèles d'origination et comportementaux"
    },
    "auto_scorecard": {
      "title": "Grille de notation",
      "description": "Grilles de notation d'adjudication et comportementales de prêts auto"
    },
    "balance_sheet_optimizer": {
      "title": "Optimiseur de bilan",
      "description": "Solveur d'optimisation de bilan (LP / NLP)"
    },
    "behavioral_models": {
      "title": "Modèles comportementaux",
      "description": "Modélisation de la fidélité des dépôts, des remboursements anticipés et de l'exercice de produits remboursables."
    },
    "bond_futures": {
      "title": "Futures sur obligations",
      "description": "Tarification des futures sur obligations d'État avec analyse cheapest-to-deliver"
    },
    "bond_options": {
      "title": "Options sur obligations",
      "description": "Options sur obligations d'État et futures sur obligations"
    },
    "borrower_risk_rating": {
      "title": "Notation de risque de l'emprunteur",
      "description": "Évaluation de la solvabilité au niveau du débiteur à l'aide de facteurs financiers et qualitatifs"
    },
    "callable_bond": {
      "title": "Obligation remboursable par anticipation",
      "description": "Obligations avec options de remboursement émetteur intégrées nécessitant une analyse OAS"
    },
    "callable_product_exercise": {
      "title": "Exercice de produits remboursables",
      "description": "Modèle d'exercice de produits remboursables (particuliers et entreprises)"
    },
    "cancellable_swap": {
      "title": "Swap résiliable",
      "description": "Swaps IR avec droits de résiliation bermudiens intégrés pour une ou les deux parties"
    },
    "capital_funding_management": {
      "title": "Gestion du capital et du financement",
      "description": "Simulation du capital réglementaire, attribution du capital économique et optimisation du financement."
    },
    "capital_planning_scenario": {
      "title": "Scénario de planification du capital",
      "description": "Moteur de scénarios de planification du capital (entrées ICAAP / CCAR)"
    },
    "cards": {
      "title": "Cartes",
      "description": "Modèles de portefeuille de cartes de crédit — scorage comportemental, prévision des pertes et gestion des limites."
    },
    "cards_allowance": {
      "title": "Provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues de cartes de crédit"
    },
    "cards_irb_ead": {
      "title": "EAD IRB",
      "description": "EAD de cartes de crédit — utilisation et facteurs de conversion de crédit"
    },
    "cards_irb_lgd": {
      "title": "LGD IRB",
      "description": "LGD de cartes de crédit — modélisation du recouvrement et des charge-offs"
    },
    "cards_irb_pd": {
      "title": "PD IRB",
      "description": "PD de cartes de crédit — scorage comportemental et transition vers la délinquance"
    },
    "cards_scorecard": {
      "title": "Grille de notation",
      "description": "Grilles de notation d'adjudication et comportementales de cartes de crédit"
    },
    "cash_allocation": {
      "title": "Allocation de trésorerie",
      "description": "Optimiseur d'allocation de trésorerie et d'investissements à court terme"
    },
    "ccr": {
      "title": "CCR",
      "description": "Modèles de risque de crédit de contrepartie — SA-CCR, simulation d'exposition PFE / EE et backtesting."
    },
    "ccr_backtesting": {
      "title": "Backtesting CCR",
      "description": "Backtesting des modèles d'exposition CCR par rapport au mark-to-market réalisé"
    },
    "cds": {
      "title": "CDS",
      "description": "Credit default swaps single-name — tarification de la protection et modélisation du spread de crédit"
    },
    "cdx": {
      "title": "CDX",
      "description": "Indices de credit default swaps — tarification du risque de crédit de portefeuille et trading de base"
    },
    "cdx_options": {
      "title": "Options sur CDX",
      "description": "Options sur indices CDX — modélisation de la volatilité et du skew du spread de crédit"
    },
    "clearing_settlement_queue": {
      "title": "File de compensation et règlement",
      "description": "Modèle de file de compensation et de règlement"
    },
    "client_risk_rating": {
      "title": "Notation du risque client",
      "description": "CRR — classification du risque client par grille de notation, déterministe et basée sur ML."
    },
    "commodity": {
      "title": "Matières premières",
      "description": "Modèles de tarification des dérivés sur matières premières."
    },
    "commodity_american_option": {
      "title": "Option américaine sur matières premières",
      "description": "Options de matières premières de type américain avec exercice anticipé et considération des coûts de stockage"
    },
    "commodity_cap_and_floor": {
      "title": "Cap et floor sur matières premières",
      "description": "Caps et floors de prix de matières premières offrant une protection coût / revenu"
    },
    "commodity_european_option": {
      "title": "Option européenne sur matières premières",
      "description": "Options de type européen sur futures de matières premières ou prix spot"
    },
    "commodity_swap": {
      "title": "Swap de matières premières",
      "description": "Swaps de matières premières fixe contre variable sur indices d'énergie, métaux et agricoles"
    },
    "commodity_swaptions": {
      "title": "Swaptions de matières premières",
      "description": "Options pour entrer dans des swaps de matières premières à prix fixes prédéterminés"
    },
    "contingency_funding": {
      "title": "Financement de contingence",
      "description": "Simulateur de plan de financement de contingence (séquenceur de tirage)"
    },
    "convertible_bond": {
      "title": "Obligation convertible",
      "description": "Instruments de dette hybrides avec options de conversion en actions intégrées"
    },
    "credit": {
      "title": "Crédit",
      "description": "Modèles de tarification des dérivés de crédit."
    },
    "credit_risk": {
      "title": "Risque de crédit",
      "description": "Modèles de risque de crédit entreprises et particuliers — notation de risque, paramètres IRB, provisions et tests de stress."
    },
    "cross_currency_swap": {
      "title": "Swap de devises",
      "description": "Swaps de devises cross-currency avec échange de nominal et fonctionnalités de reset FX"
    },
    "cva": {
      "title": "CVA",
      "description": "Modèles d'ajustement de valeur de crédit — CVA comptable et SA-CVA réglementaire."
    },
    "cva_fva_dva_calculator": {
      "title": "Calculateur CVA / FVA / DVA",
      "description": "Calculateur CVA / FVA / DVA"
    },
    "cva_model": {
      "title": "CVA",
      "description": "CVA comptable — perte attendue en cas de défaut de contrepartie sur les portefeuilles de dérivés"
    },
    "deposit_behavioral_runoff": {
      "title": "Écoulement comportemental des dépôts",
      "description": "Modèle d'écoulement comportemental des dépôts (core vs non-core)"
    },
    "deposit_behavioral_segmentation": {
      "title": "Segmentation comportementale des dépôts",
      "description": "Modèle de segmentation comportementale des dépôts"
    },
    "derivative_pricing_models": {
      "title": "Modèles de tarification des dérivés",
      "description": "Validez les modèles de tarification des dérivés sur les classes d'actifs FX, actions, IR, matières premières et crédit."
    },
    "deterministic_crr": {
      "title": "CRR déterministe",
      "description": "CRR déterministe — notation du risque client à base de règles déterministes"
    },
    "direct_cf_hedge": {
      "title": "Couverture directe de flux de trésorerie",
      "description": "Moteur d'efficacité de couverture directe de flux de trésorerie"
    },
    "direct_fv_hedge": {
      "title": "Couverture directe de juste valeur",
      "description": "Moteur d'efficacité de couverture directe de juste valeur"
    },
    "dynamic_cf_hedge": {
      "title": "Couverture dynamique de flux de trésorerie",
      "description": "Moteur d'efficacité de couverture dynamique de flux de trésorerie"
    },
    "dynamic_fv_hedge": {
      "title": "Couverture dynamique de juste valeur",
      "description": "Moteur d'efficacité de couverture dynamique de juste valeur"
    },
    "economic_capital": {
      "title": "Capital économique",
      "description": "Modèle d'allocation du capital économique (attribution du risque)"
    },
    "effectiveness_testing": {
      "title": "Test d'efficacité",
      "description": "Évaluation de l'efficacité de couverture selon les cadres IFRS 9 et US GAAP (ASC 815)."
    },
    "equity": {
      "title": "Actions",
      "description": "Modèles de tarification des dérivés actions."
    },
    "equity_american_option": {
      "title": "Option américaine sur actions",
      "description": "Options actions de type américain avec exercice anticipé"
    },
    "equity_asian_option": {
      "title": "Option asiatique sur actions",
      "description": "Options actions dépendantes du chemin avec payoff de prix moyen ou strike moyen"
    },
    "equity_autocallable_note": {
      "title": "Note autocallable sur actions",
      "description": "Notes structurées avec remboursement anticipé automatique aux dates d'observation de coupon"
    },
    "equity_barrier_option": {
      "title": "Option à barrière sur actions",
      "description": "Options actions qui s'activent ou s'éteignent à des niveaux barrières spécifiés"
    },
    "equity_digital_option": {
      "title": "Option digitale sur actions",
      "description": "Options actions avec payout fixe conditionnel à une clôture ITM"
    },
    "equity_european_option": {
      "title": "Option européenne sur actions",
      "description": "Options vanille de type européen sur actions exerçables à l'échéance"
    },
    "equity_forward": {
      "title": "Forward sur actions",
      "description": "Contrats forward sur actions individuelles ou indices actions"
    },
    "equity_forward_starting_option": {
      "title": "Option à départ différé sur actions",
      "description": "Options sur actions dont le strike est fixé à une date future plutôt qu'à l'initiation"
    },
    "equity_futures": {
      "title": "Futures sur actions",
      "description": "Futures sur indices actions et actions individuelles négociés en bourse"
    },
    "equity_touch_option": {
      "title": "Option à touche sur actions",
      "description": "Options actions binaires payant un montant fixe lors du contact avec une barrière"
    },
    "eve_calculator": {
      "title": "Calculateur d'EVE",
      "description": "Calculateur d'EVE (suite de chocs réglementaires)"
    },
    "facility_risk_rating": {
      "title": "Notation de risque de la facilité",
      "description": "Évaluation du risque au niveau de la facilité intégrant les sûretés, la structure et la séniorité"
    },
    "fair_value_hierarchy": {
      "title": "Hiérarchie de juste valeur",
      "description": "Réconciliateur de hiérarchie de juste valeur"
    },
    "financial_crimes": {
      "title": "Criminalité financière",
      "description": "Modèles AML de surveillance des transactions, notation du risque client et filtrage des sanctions."
    },
    "financial_resource_optimization": {
      "title": "Optimisation des ressources financières",
      "description": "Tarification des transferts de fonds, optimisation du bilan, gestion du capital et du financement."
    },
    "fraud": {
      "title": "Fraude",
      "description": "Modèles de détection et prévention de la fraude — scorage de fraude sur transactions, comptes, connexions et sinistres."
    },
    "fraud_account_scoring": {
      "title": "Scorage de comptes",
      "description": "Plateforme de scorage du risque de fraude basée sur la connectivité des comptes bancaires"
    },
    "fraud_call_risk_scoring": {
      "title": "Scorage de risque d'appels",
      "description": "Solution d'évaluation et de priorisation du risque des appels téléphoniques"
    },
    "fraud_credit_card_claims": {
      "title": "Litiges de cartes de crédit",
      "description": "Système d'évaluation de la probabilité de fraude sur les litiges de cartes de crédit"
    },
    "fraud_credit_risk": {
      "title": "Risque de crédit",
      "description": "Classificateur de risque de demandes hypothécaires résidentielles"
    },
    "fraud_data_loss_prevention": {
      "title": "Prévention des pertes de données",
      "description": "Système de détection d'anomalies d'activité d'impression des employés"
    },
    "fraud_insurance_investigation": {
      "title": "Enquête d'assurance",
      "description": "Solution de recommandation pour l'enquête de sinistres automobiles"
    },
    "fraud_login_portal": {
      "title": "Portail de connexion",
      "description": "Solution de détection de fraude sur les portails de connexion en ligne et mobiles"
    },
    "fraud_online_banking": {
      "title": "Services bancaires en ligne",
      "description": "Système de scorage et de surveillance du risque des transactions de banque en ligne"
    },
    "fraud_transaction_detection": {
      "title": "Détection de transactions",
      "description": "Détection en temps réel des anomalies de transactions pour DAB, mobile, retraits, débit"
    },
    "fraud_transaction_monitoring": {
      "title": "Surveillance des transactions",
      "description": "Solution de scorage de virements à haut risque"
    },
    "fraud_wealth_segmentation": {
      "title": "Segmentation fortunée",
      "description": "Segmentation et sélection de variables de portefeuille fortuné"
    },
    "ftp_curve_construction": {
      "title": "Construction de courbe FTP",
      "description": "Module de construction et de calibration de courbe FTP"
    },
    "funding_concentration": {
      "title": "Concentration de financement",
      "description": "Modèle de concentration de financement et d'exposition aux contreparties (entrées ICAAP / CCAR)"
    },
    "funding_cost_allocation": {
      "title": "Allocation des coûts de financement",
      "description": "Modèle d'allocation des coûts de financement (FTP transactionnel)"
    },
    "funding_mix_optimization": {
      "title": "Optimisation du mix de financement",
      "description": "Modèle d'optimisation du mix et de la tenue du financement"
    },
    "funding_mix_tenor": {
      "title": "Mix et tenue du financement",
      "description": "Modèle d'optimisation de mix et de tenue du financement (coût vs liquidité)"
    },
    "funds_transfer_pricing": {
      "title": "Tarification des transferts de fonds",
      "description": "Tarification interne des fonds entre lignes métier et trésorerie."
    },
    "fx": {
      "title": "FX",
      "description": "Modèles de tarification des dérivés de change."
    },
    "fx_american_option": {
      "title": "Option américaine FX",
      "description": "Options FX de type américain exerçables à tout moment jusqu'à l'échéance"
    },
    "fx_asian_option": {
      "title": "Option asiatique FX",
      "description": "Options FX dépendantes du chemin avec payoff basé sur le taux moyen sur une période"
    },
    "fx_barrier_option": {
      "title": "Option à barrière FX",
      "description": "Options FX qui s'activent ou s'éteignent lorsque le taux spot franchit un niveau barrière"
    },
    "fx_digital_option": {
      "title": "Option digitale FX",
      "description": "Options FX avec payout fixe conditionnel à une clôture du spot au-dessus ou en dessous d'un strike"
    },
    "fx_european_option": {
      "title": "Option européenne FX",
      "description": "Options FX vanille de type européen exerçables uniquement à l'échéance"
    },
    "fx_forward": {
      "title": "Forward FX",
      "description": "Contrats forward outright sur paires de devises avec règlement à une date future"
    },
    "fx_futures": {
      "title": "Futures FX",
      "description": "Contrats futures standardisés sur devises négociés en bourse"
    },
    "fx_range_accrual": {
      "title": "Range accrual FX",
      "description": "Notes structurées FX accumulant le coupon selon les jours où le spot reste dans une fourchette"
    },
    "fx_touch_option": {
      "title": "Option à touche FX",
      "description": "Options FX binaires qui paient un montant fixe si le spot touche un niveau spécifié"
    },
    "genai": {
      "title": "IA générative",
      "description": "Modèles d'IA générative — souscription, surveillance, génération de code, chatbots et résumé."
    },
    "genai_carrier_booklet_extraction": {
      "title": "Extraction de livrets d'assureurs",
      "description": "Outil d'extraction et de structuration des données de livrets d'assureurs antérieurs"
    },
    "genai_chatbots": {
      "title": "Chatbots",
      "description": "Écosystème de chatbots de connaissance et de support internes"
    },
    "genai_code_assistant": {
      "title": "Assistant de code",
      "description": "Suite d'assistants de productivité développeur et de génération de code"
    },
    "genai_code_conversion": {
      "title": "Conversion de code",
      "description": "Plateforme d'explication et de conversion du code FOCUS hérité"
    },
    "genai_comms_monitoring": {
      "title": "Surveillance des communications",
      "description": "Système de surveillance des communications des employés et de détection de conformité"
    },
    "genai_news_classification": {
      "title": "Classification d'actualités",
      "description": "Solution de catégorisation et de résumé d'événements d'actualité externes"
    },
    "genai_summarization": {
      "title": "Résumé",
      "description": "Plateforme automatisée de résumé des conversations de centre d'appels"
    },
    "genai_surveillance": {
      "title": "Surveillance",
      "description": "Surveillance des communications et de la voix des employés pour la détection des risques de conformité."
    },
    "genai_underwriting": {
      "title": "Souscription",
      "description": "Recommandation de souscription et extraction de données propulsées par l'IA générative."
    },
    "genai_underwriting_recommendation": {
      "title": "Recommandation de souscription",
      "description": "Plateforme automatisée de recommandation et d'assistance à la souscription"
    },
    "genai_voice_surveillance": {
      "title": "Surveillance vocale",
      "description": "Surveillance des communications vocales des employés et détection des risques"
    },
    "hedge_accounting": {
      "title": "Comptabilité de couverture",
      "description": "Modèles d'évaluation et de tests d'efficacité de couverture."
    },
    "hedge_rebalancing_backtest": {
      "title": "Backtest du rééquilibrage de couverture",
      "description": "Modèle de backtest de rééquilibrage et d'efficacité de couverture"
    },
    "hedge_rebalancing_scheduler": {
      "title": "Planificateur de rééquilibrage de couverture",
      "description": "Planificateur de rééquilibrage de couverture et module de recommandation de transactions"
    },
    "heloc": {
      "title": "HELOC",
      "description": "Modèles de marges de crédit hypothécaires — comportement de tirage, suivi des sûretés et prévision des pertes."
    },
    "heloc_allowance": {
      "title": "Provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues HELOC"
    },
    "heloc_irb_ead": {
      "title": "EAD IRB",
      "description": "EAD HELOC — modélisation du comportement de tirage et d'utilisation"
    },
    "heloc_irb_lgd": {
      "title": "LGD IRB",
      "description": "LGD HELOC — modélisation combinée de la position du privilège et de la valeur de la propriété"
    },
    "heloc_irb_pd": {
      "title": "PD IRB",
      "description": "PD HELOC — facteurs de risque combinés hypothécaire et renouvelable"
    },
    "intraday_limit_breach": {
      "title": "Dépassement de limite intrajournalière",
      "description": "Prédicteur de dépassement de limite intrajournalière"
    },
    "intraday_liquidity_engine": {
      "title": "Moteur de liquidité intrajournalière",
      "description": "Simulateur de flux de paiement"
    },
    "ir": {
      "title": "IR",
      "description": "Modèles de tarification des dérivés de taux d'intérêt."
    },
    "ir_bermudan_swaption": {
      "title": "Swaption bermudienne IR",
      "description": "Swaptions bermudiennes avec dates d'exercice multiples nécessitant des méthodes en arbre / MC"
    },
    "ir_range_accrual": {
      "title": "Range accrual IR",
      "description": "Notes à accumulation de coupon basée sur le maintien d'un taux de référence dans un corridor"
    },
    "ir_cap_and_floor": {
      "title": "Cap et floor IR",
      "description": "Caps et floors de taux d'intérêt — séries de caplets / floorlets sur taux variables"
    },
    "ir_european_swaption": {
      "title": "Swaption européenne IR",
      "description": "Swaptions de type européen — droit d'entrer dans un swap IR à un taux fixe à l'échéance"
    },
    "ir_future_options": {
      "title": "Options sur futures IR",
      "description": "Options sur contrats futures de taux d'intérêt à court terme"
    },
    "ir_futures": {
      "title": "Futures IR",
      "description": "Tarification des futures de taux à court terme (Eurodollar, SOFR) et ajustement de convexité"
    },
    "ir_swap": {
      "title": "Swap IR",
      "description": "Swaps de taux vanille et de base avec actualisation multi-courbe"
    },
    "irb_parameter_models": {
      "title": "Modèles de paramètres IRB",
      "description": "Estimation des paramètres en approche notations internes pour le capital réglementaire."
    },
    "irrbb_measurement": {
      "title": "Mesure de l'IRRBB",
      "description": "Sensibilité de la valeur économique et du produit net d'intérêts aux variations des taux d'intérêt."
    },
    "irrbb_reporting_reconciler": {
      "title": "Réconciliateur de reporting IRRBB",
      "description": "Réconciliateur de reporting IRRBB"
    },
    "isda_simm": {
      "title": "ISDA SIMM",
      "description": "ISDA SIMM — calcul de marge initiale basé sur les sensibilités à travers les classes de risque"
    },
    "issuance_timing": {
      "title": "Calendrier d'émission",
      "description": "Optimiseur de calendrier et de tarification d'émission"
    },
    "lcr_calculator": {
      "title": "Calculateur LCR",
      "description": "Module de réconciliation haute fréquence"
    },
    "lcr_nsfr_nccf_mapping": {
      "title": "Cartographie LCR / NSFR / NCCF",
      "description": "Moteur de cartographie des flux LCR / NSFR / NCCF"
    },
    "liquidity": {
      "title": "Liquidité",
      "description": "Reporting réglementaire, prévision à court terme, planification à long terme et tests de stress."
    },
    "liquidity_buffer_drawdown": {
      "title": "Tirage du coussin de liquidité",
      "description": "Modèle de tirage du coussin de liquidité (séquenceur de liquidation d'actifs)"
    },
    "liquidity_cost_minimization": {
      "title": "Minimisation des coûts de liquidité",
      "description": "Modèle de minimisation des coûts de liquidité (fonctions de pénalité)"
    },
    "liquidity_ratio_reconciler": {
      "title": "Réconciliateur de ratios de liquidité",
      "description": "Générateur de dossier de soumission"
    },
    "liquidity_stress": {
      "title": "Stress de liquidité",
      "description": "Moteur de scénarios de stress de liquidité (scénarios réglementaires et internes)"
    },
    "long_term_planning": {
      "title": "Planification à long terme",
      "description": "Projection de liquidité à moyen et long terme, gestion des maturités et modélisation comportementale."
    },
    "machine_learning": {
      "title": "Modèles d'apprentissage automatique",
      "description": "Modèles IA / ML, NLP, IA générative et détection de fraude couvrant les domaines de l'assurance, de la banque et de l'entreprise."
    },
    "market_risk": {
      "title": "Risque de marché",
      "description": "Modèles VaR / ES, risque de crédit de contrepartie, CVA et SIMM pour les portefeuilles de trading et les dérivés."
    },
    "maturity_ladder": {
      "title": "Échelle de maturité",
      "description": "Agrégateur d'échelle de maturité et moteur de report"
    },
    "medium_term_liquidity": {
      "title": "Liquidité à moyen terme",
      "description": "Projection de liquidité à moyen terme 1-12 m (mélange de scénarios)"
    },
    "ml_based_crr": {
      "title": "CRR basé sur ML",
      "description": "CRR basé sur ML — classification du risque client par apprentissage automatique"
    },
    "ml_based_tm": {
      "title": "TM basé sur ML",
      "description": "TM basé sur ML — modèles entraînés sur variables (gradient boosted trees, NLP, IA générative)"
    },
    "ml_credit_distress_prediction": {
      "title": "Prédiction de détresse de crédit",
      "description": "Plateforme de prédiction de détresse de crédit des partenaires d'affaires"
    },
    "ml_credit_risk_assessment": {
      "title": "Évaluation du risque de crédit",
      "description": "Modèles de prédiction, segmentation et classification du risque de crédit pilotés par ML."
    },
    "ml_customer_data_mgmt": {
      "title": "Gestion des données clients",
      "description": "Moteur de réconciliation et d'appariement démographique des clients"
    },
    "ml_data_loss_prevention": {
      "title": "Prévention des pertes de données",
      "description": "Système de détection d'anomalies d'activité d'impression des employés"
    },
    "ml_etl_preprocessing": {
      "title": "ETL / prétraitement",
      "description": "Pipeline d'extraction, transformation et ingénierie de variables"
    },
    "ml_high_risk_wire_scoring": {
      "title": "Scorage de virements à haut risque",
      "description": "Solution de scorage de virements à haut risque"
    },
    "ml_insurance_investigation": {
      "title": "Enquête d'assurance",
      "description": "Solution de recommandation pour l'enquête de sinistres automobiles"
    },
    "ml_insurance_pricing": {
      "title": "Tarification d'assurance",
      "description": "Outil de prédiction de la sévérité des sinistres en assurance résidentielle"
    },
    "ml_insurance_underwriting": {
      "title": "Souscription d'assurance",
      "description": "Système de décision en temps réel pour la souscription d'assurance vie"
    },
    "ml_marketing": {
      "title": "Marketing",
      "description": "Moteur de recommandations marketing pour clients particuliers"
    },
    "ml_mortgage_risk_classifier": {
      "title": "Classificateur de risque hypothécaire",
      "description": "Classificateur de risque de demandes hypothécaires résidentielles"
    },
    "ml_transaction_monitoring": {
      "title": "Surveillance des transactions",
      "description": "Scorage de transactions et réduction d'alertes basés sur ML pour les virements."
    },
    "ml_wealth_portfolio_selection": {
      "title": "Sélection de variables de portefeuille fortuné",
      "description": "Segmentation et sélection de variables de portefeuille fortuné"
    },
    "ml_wealth_segmentation": {
      "title": "Segmentation de clients fortunés",
      "description": "Segmentation des clients fortunés et clustering pour conseil"
    },
    "ml_wire_alert_reduction": {
      "title": "Réduction d'alertes sur virements",
      "description": "Système de réduction d'alertes sur virements en banque personnelle"
    },
    "mortgage": {
      "title": "Hypothèque",
      "description": "Modèles de prêts hypothécaires résidentiels — paramètres IRB, grilles de notation, provisions et tests de stress."
    },
    "mortgage_allowance": {
      "title": "Provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues hypothécaires avec scénarios HPI"
    },
    "mortgage_irb_ead": {
      "title": "EAD IRB",
      "description": "EAD hypothécaire — amortissement, remboursement anticipé et modélisation du tirage HELOC"
    },
    "mortgage_irb_lgd": {
      "title": "LGD IRB",
      "description": "LGD hypothécaire — évaluation des sûretés, taux de recouvrement et couverture d'assurance"
    },
    "mortgage_irb_pd": {
      "title": "PD IRB",
      "description": "PD hypothécaire — segmentation des pools, calibration et planchers réglementaires selon OSFI CAR"
    },
    "mortgage_scorecard": {
      "title": "Grille de notation",
      "description": "Grilles de notation d'adjudication et comportementales hypothécaires pour la décision de crédit"
    },
    "mortgage_stress": {
      "title": "Tests de stress",
      "description": "Projections de pertes hypothécaires en stress sous scénarios défavorables du logement et macroéconomiques"
    },
    "name_screening": {
      "title": "Filtrage des noms",
      "description": "Mise en correspondance des noms de clients / contreparties avec les sanctions et listes de surveillance"
    },
    "nii_projection": {
      "title": "Projection NII",
      "description": "Modèle de projection NII (base, défavorable, sévère)"
    },
    "nii_shock_simulator": {
      "title": "Simulateur de choc NII",
      "description": "Simulateur de choc NII (parallèle, twist, personnalisé)"
    },
    "nlp": {
      "title": "NLP",
      "description": "Modèles de traitement du langage naturel — classification, reconnaissance d'entités, sentiment et résumé."
    },
    "nlp_chatbots": {
      "title": "Chatbots",
      "description": "Suite de chatbots de support et d'information pour les employés internes"
    },
    "nlp_document_masking": {
      "title": "Masquage de documents",
      "description": "Solution d'anonymisation et de masquage des PII dans les commentaires d'enquête"
    },
    "nlp_intent_classification": {
      "title": "Classification d'intention",
      "description": "Plateforme de catégorisation d'intention des clients en centre d'appels"
    },
    "nlp_marketing_asset_analysis": {
      "title": "Analyse d'actifs marketing",
      "description": "Solution d'évaluation et de scorage d'actifs marketing sur les médias sociaux"
    },
    "nlp_named_entity_recognition": {
      "title": "Reconnaissance d'entités nommées",
      "description": "Identification et masquage des noms personnels dans les commentaires d'enquête"
    },
    "nlp_news_classification": {
      "title": "Classification d'actualités",
      "description": "Catégorisation d'événements d'actualité externes pour la planification d'audit"
    },
    "nlp_sentiment_analysis": {
      "title": "Analyse de sentiment",
      "description": "Système de détection et d'étiquetage du sentiment dans les commentaires d'enquête"
    },
    "nlp_summarization": {
      "title": "Résumé",
      "description": "Outil de résumé et de transcription des conversations de centre d'appels"
    },
    "nlp_topic_classification": {
      "title": "Classification de sujets",
      "description": "Outil de catégorisation et d'analyse de sujets de commentaires d'enquête"
    },
    "ois_discounting": {
      "title": "Actualisation OIS",
      "description": "Module d'actualisation OIS et d'ajustement de base"
    },
    "operational_risk_simulator": {
      "title": "Simulateur de risque opérationnel",
      "description": "Simulateur de risque opérationnel (entrées ICAAP / CCAR)"
    },
    "option_adjusted_valuation": {
      "title": "Évaluation ajustée des options",
      "description": "Modèle d'évaluation ajustée des options (OAV)"
    },
    "parameter_calibration": {
      "title": "Calibration des paramètres",
      "description": "Calibration des paramètres de drift, volatilité et corrélation pour la simulation d'exposition"
    },
    "payment_flow_concentration": {
      "title": "Concentration des flux de paiement",
      "description": "Analyseur de concentration des flux de paiement"
    },
    "payment_screening": {
      "title": "Filtrage des paiements",
      "description": "Filtrage des messages de paiement par rapport aux listes de sanctions"
    },
    "personal_allowance": {
      "title": "Provisions",
      "description": "Modèles IFRS 9 / CECL de pertes de crédit attendues de prêts personnels"
    },
    "personal_irb_lgd": {
      "title": "LGD IRB",
      "description": "LGD de prêts personnels — modélisation du recouvrement non garanti"
    },
    "personal_irb_pd": {
      "title": "PD IRB",
      "description": "PD de prêts personnels — évaluation du risque non garanti"
    },
    "personal_lending": {
      "title": "Prêt personnel",
      "description": "Modèles de prêts personnels et lignes de crédit non garantis."
    },
    "personal_scorecard": {
      "title": "Grille de notation",
      "description": "Grilles de notation d'adjudication et comportementales de prêts personnels"
    },
    "pfe_ee": {
      "title": "PFE / EE",
      "description": "Modèles de simulation d'exposition future potentielle et d'exposition attendue."
    },
    "precious_metal_range_accrual": {
      "title": "Range accrual sur métaux précieux",
      "description": "Notes structurées accumulant le coupon selon le maintien des prix or / argent dans une fourchette"
    },
    "prepayment_cpr": {
      "title": "CPR de remboursement anticipé",
      "description": "Modèle de remboursement anticipé / CPR (vieillissement et épuisement hypothécaire)"
    },
    "rate_scenario_monte_carlo": {
      "title": "Monte Carlo de scénarios de taux",
      "description": "Moteur Monte Carlo de scénarios de taux (trajectoires stochastiques)"
    },
    "recovery_funding": {
      "title": "Financement de redressement",
      "description": "Séquenceur de financement de redressement (priorisation des sources de financement)"
    },
    "regulatory_capital_simulator": {
      "title": "Simulateur de capital réglementaire",
      "description": "Simulateur d'impact sur le capital réglementaire (Basel)"
    },
    "regulatory_reporting": {
      "title": "Reporting réglementaire",
      "description": "Calcul et réconciliation des ratios réglementaires de liquidité LCR, NSFR et NCCF."
    },
    "repricing_ladder": {
      "title": "Échelle de retarification",
      "description": "Agrégateur d'échelle de retarification (par tranche et par produit)"
    },
    "retail": {
      "title": "Particuliers",
      "description": "Modèles de risque de crédit particuliers pour les portefeuilles de prêts à la consommation."
    },
    "retail_deposit_stickiness": {
      "title": "Fidélité des dépôts particuliers",
      "description": "Modèle de fidélité et de décroissance des dépôts particuliers"
    },
    "reverse_liquidity_stress": {
      "title": "Stress de liquidité inversé",
      "description": "Testeur de stress de liquidité inversé (idiosyncratique et marché)"
    },
    "risk_rating_models": {
      "title": "Modèles de notation de risque",
      "description": "Modèles de notation de risque de crédit au niveau de l'emprunteur et de la facilité."
    },
    "run_off_roll_rate": {
      "title": "Taux d'écoulement et de renouvellement",
      "description": "Modèle d'écoulement et de taux de renouvellement (par produit)"
    },
    "sa_ccr": {
      "title": "SA-CCR",
      "description": "Approche standardisée pour le risque de crédit de contrepartie — calcul réglementaire de l'EAD"
    },
    "sa_cva": {
      "title": "SA-CVA",
      "description": "CVA en approche standardisée — exigence de capital réglementaire pour le risque CVA (FRTB)"
    },
    "sabr_vol_calibration": {
      "title": "Calibration de volatilité SABR",
      "description": "Calibration du modèle de volatilité stochastique SABR pour les surfaces de volatilité des swaptions et caps / floors"
    },
    "sanctions_screening": {
      "title": "Filtrage des sanctions",
      "description": "Filtrage des noms et des paiements par rapport aux sanctions et listes de surveillance."
    },
    "scenario_asset_allocation": {
      "title": "Allocation d'actifs par scénario",
      "description": "Moteur d'allocation d'actifs par scénario (sensible au stress)"
    },
    "scorecard_ph": {
      "title": "Grille de notation PH",
      "description": "PH par grille de notation — scorage additif avec seuil EDD pour les clients potentiellement à risque élevé"
    },
    "short_term_cashflow_branch": {
      "title": "Trésorerie à court terme (succursale)",
      "description": "Prévision de trésorerie à court terme (succursale et entreprises)"
    },
    "short_term_cashflow_treasury": {
      "title": "Trésorerie à court terme (desk trésorerie)",
      "description": "Prévision de trésorerie à court terme (desk trésorerie)"
    },
    "short_term_forecasting": {
      "title": "Prévision à court terme",
      "description": "Prévision intrajournalière et à court terme des flux de trésorerie pour les opérations de trésorerie."
    },
    "simm": {
      "title": "SIMM",
      "description": "Modèle de marge initiale standard pour les dérivés OTC non compensés."
    },
    "simm_backtesting": {
      "title": "Backtesting",
      "description": "Backtesting SIMM — validation de l'adéquation de la marge par rapport au P&L réalisé"
    },
    "simulation_exposure_generation": {
      "title": "Simulation et génération d'exposition",
      "description": "Moteur de simulation Monte Carlo pour la génération de profils PFE / EE"
    },
    "strategic_ftp": {
      "title": "FTP stratégique",
      "description": "Optimiseur FTP stratégique (marges par ligne métier)"
    },
    "stress_funding_recovery": {
      "title": "Financement de stress et redressement",
      "description": "Planificateur de financement de stress et de redressement (scénarios réglementaires)"
    },
    "stress_period_selection": {
      "title": "Sélection de période de stress",
      "description": "Calibration de la VaR en stress — identification de la fenêtre historique de stress la plus défavorable"
    },
    "stress_testing_aggregation": {
      "title": "Tests de stress",
      "description": "Moteurs de scénarios de stress de liquidité, tests de stress inversés et financement de contingence."
    },
    "stress_testing_models": {
      "title": "Modèles de tests de stress",
      "description": "Modèles de paramètres de tests de stress pour ICAAP, CCAR et scénarios réglementaires."
    },
    "structural_market_risk": {
      "title": "Risque de marché structurel (hors trading)",
      "description": "Mesure de l'IRRBB, modèles comportementaux et construction de courbe des taux."
    },
    "transaction_monitoring": {
      "title": "Surveillance des transactions",
      "description": "Surveillance AML/ATF des transactions — modèles de détection à base de règles et basés sur ML."
    },
    "transactional_ftp": {
      "title": "FTP transactionnel",
      "description": "Moteur FTP transactionnel (niveau opération)"
    },
    "treasury": {
      "title": "Trésorerie",
      "description": "Modèles de liquidité, risque de marché structurel, optimisation des ressources financières et comptabilité de couverture."
    },
    "treasury_portfolio_rebalancer": {
      "title": "Rééquilibreur de portefeuille de trésorerie",
      "description": "Rééquilibreur de portefeuille de trésorerie (objectifs de duration et de liquidité)"
    },
    "valuation": {
      "title": "Évaluation",
      "description": "Mesure de la juste valeur incluant CVA, FVA, DVA et hiérarchie d'évaluation."
    },
    "var_es": {
      "title": "VaR / ES",
      "description": "Modèles de Value at Risk et d'Expected Shortfall pour la mesure du risque du portefeuille de négociation."
    },
    "var_es_engine": {
      "title": "Moteur VaR / ES",
      "description": "Moteurs de calcul VaR / ES par simulation historique, paramétrique et Monte Carlo"
    },
    "wholesale": {
      "title": "Entreprises",
      "description": "Modèles de risque de crédit entreprises pour les expositions commerciales, corporate et institutions financières."
    },
    "wholesale_ead_calibration": {
      "title": "Calibration de l'EAD",
      "description": "Estimation du facteur de conversion de crédit et calibration de l'EAD"
    },
    "wholesale_ead_segmentation": {
      "title": "Segmentation de l'EAD",
      "description": "Segmentation de l'exposition au défaut pour les facilités renouvelables et à terme"
    },
    "wholesale_ecl_ead": {
      "title": "EAD pour ECL",
      "description": "Estimation de l'EAD sur la durée de vie pour l'ECL avec profils d'amortissement et de tirage"
    },
    "wholesale_ecl_lgd": {
      "title": "LGD pour ECL",
      "description": "Estimation de la LGD sur la durée de vie pour l'ECL avec modélisation de courbe de recouvrement"
    },
    "wholesale_ecl_pd": {
      "title": "PD pour ECL",
      "description": "PD point-in-time avec informations prospectives pour l'estimation de l'ECL"
    },
    "wholesale_lgd_calibration": {
      "title": "Calibration de la LGD",
      "description": "Calibration de la LGD en récession avec modélisation du recouvrement"
    },
    "wholesale_lgd_segmentation": {
      "title": "Segmentation de la LGD",
      "description": "Segmentation de la perte en cas de défaut par type de sûreté et séniorité"
    },
    "wholesale_pd_calibration": {
      "title": "Calibration de la PD",
      "description": "Calibration de la PD moyenne long terme et marge de prudence"
    },
    "wholesale_pd_segmentation": {
      "title": "Segmentation de la PD",
      "description": "Segmentation du risque de probabilité de défaut et affectation aux pools"
    },
    "wholesale_sicr": {
      "title": "SICR",
      "description": "Modèle d'étapes d'augmentation significative du risque de crédit (affectation Stage 1 / 2 / 3)"
    },
    "wholesale_stress_ead": {
      "title": "EAD en stress",
      "description": "Estimation de l'EAD en stress avec comportement de tirage en stress"
    },
    "wholesale_stress_lgd": {
      "title": "LGD en stress",
      "description": "Estimation de la LGD en stress sous conditions de récession"
    },
    "wholesale_stress_pd": {
      "title": "PD en stress",
      "description": "Projection de PD en stress sous scénarios macroéconomiques défavorables"
    },
    "yield_curve_construction": {
      "title": "Construction de courbe des taux",
      "description": "Moteur de construction et de bootstrapping de courbe des taux"
    },
    "yield_curve_models": {
      "title": "Modèles de courbe des taux",
      "description": "Construction de courbe des taux, bootstrapping et cadre multi-courbe."
    },
    "capital_models": {
      "title": "Modèles de capital",
      "description": "Calcul du capital réglementaire et approches FRTB pour le risque de marché du portefeuille de négociation."
    },
    "frtb": {
      "title": "FRTB",
      "description": "Revue fondamentale du portefeuille de négociation — Approche standard (SA) et Approche par modèles internes (IMA) pour le capital de risque de marché."
    },
    "insurance": {
      "title": "Assurance",
      "description": "Modèles d'assurance et actuariels — tarification, provisionnement, capital et études d'expérience."
    },
    "life": {
      "title": "Vie",
      "description": "Modèles d'assurance vie et de rentes — tarification, évaluation, capital et études d'expérience."
    },
    "life_valuation": {
      "title": "Évaluation",
      "description": "Calcul des engagements, des provisions et des résultats financiers de l'assureur pour les polices d'assurance vie."
    },
    "p_and_c": {
      "title": "IARD",
      "description": "Modèles IARD — tarification, provisionnement et capital."
    },
    "pricing": {
      "title": "Tarification",
      "description": "Modèles de tarification et de fixation des taux."
    },
    "reserving": {
      "title": "Provisionnement",
      "description": "Modèles de provisionnement des sinistres et d'estimation des engagements."
    }
  },
  "serviceTypes": {
    "Auditing": {
      "title": "Audit",
      "description": "Audit complet de la gouvernance, des contrôles et de la conformité réglementaire du modèle"
    },
    "Development": {
      "title": "Développement",
      "description": "Support de développement, d'amélioration et de documentation des modèles"
    },
    "Validation": {
      "title": "Validation",
      "description": "Examen et validation indépendants des hypothèses, de la méthodologie et des résultats du modèle"
    }
  },
  "generic": {
    "title": "Tâche générique",
    "description": "Validez ou auditez un modèle qui ne correspond pas à une catégorie prédéfinie."
  },
  "inventory": {
    "models": {
      "1": {
        "name": "Modèle de PD du risque de crédit v2.1",
        "type": "Risque de crédit",
        "description": "Modèle de probabilité de défaut pour les portefeuilles hypothécaires particuliers",
        "owner": "Équipe Analytique des risques",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Particuliers",
        "dataSource": "Base de données de crédit interne"
      },
      "3": {
        "name": "Modèle de calcul de l'EAD",
        "type": "Risque de crédit",
        "description": "Calcul de l'exposition au défaut pour les exigences de capital de risque de crédit",
        "owner": "Gestion du capital",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Entreprises",
        "dataSource": "Base de données des transactions"
      },
      "4": {
        "name": "Modèle de scorage de crédit — Particuliers",
        "type": "Risque de crédit",
        "description": "Modèle de scorage à l'application pour les produits de crédit aux particuliers",
        "owner": "Banque aux particuliers",
        "regulatoryFramework": "Fair Lending",
        "modelCategory": "Particuliers",
        "dataSource": "Données de demandes"
      },
      "2": {
        "name": "Modèle d'estimation de la LGD",
        "type": "Risque de crédit",
        "description": "Modèle d'estimation de la perte en cas de défaut pour les prêts aux entreprises",
        "owner": "Équipe Risque de crédit",
        "regulatoryFramework": "IFRS 9",
        "modelCategory": "Entreprises",
        "dataSource": "Données historiques de pertes"
      },
      "11": {
        "name": "Modèle de VaR du risque de marché",
        "type": "Risque de marché",
        "description": "Calcul de la Value at Risk pour la gestion du risque du portefeuille de négociation",
        "owner": "Équipe Risque de marché",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Négociation",
        "dataSource": "Flux de données de marché"
      },
      "12": {
        "name": "Calculateur de Greeks du risque de marché",
        "type": "Risque de marché",
        "description": "Calculs des Delta, Gamma, Vega et Theta pour le portefeuille de dérivés",
        "owner": "Desk Dérivés",
        "regulatoryFramework": "Basel III",
        "modelCategory": "Dérivés",
        "dataSource": "Moteur de tarification"
      },
      "50": {
        "name": "Pricer d'options européennes FX",
        "type": "Modèles de tarification",
        "description": "Pricer en forme close pour les options FX européennes vanille",
        "owner": "Développement de modèles",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "FX",
        "dataSource": "Flux de données de marché"
      },
      "51": {
        "name": "Pricer de swap IR",
        "type": "Modèles de tarification",
        "description": "Pricer de swap avec courbes d'actualisation et de projection et sensibilités",
        "owner": "Recherche quantitative",
        "regulatoryFramework": "SR 11-7",
        "modelCategory": "IR",
        "dataSource": "Constructeur de courbes"
      },
      "52": {
        "name": "Pricer d'options européennes sur matières premières",
        "type": "Modèles de tarification",
        "description": "Pricer d'options vanille sur matières premières avec hooks de calibration"
      }
    },
    "statuses": {
      "Active": "Actif",
      "Draft": "Brouillon",
      "Deprecated": "Obsolète"
    }
  }
}
